import { useMedia } from 'react-use'

export const useDesktopQuery = () => useMedia('(min-width: 600px)')
export const useMobileQuery = () => useMedia('(max-width: 320px)')
